import { Bar, mixins } from 'vue-chartjs';
import Vue from 'vue/dist/vue.js';
const { reactiveProp } = mixins;

export default {
    init(){
        Vue.component("bar-chart", {
            extends: Bar,
            mixins: [reactiveProp],
            props: ["barChartData","options"],
            mounted() {
                this.renderChart(this.chartData, this.options);
            },
        });
    }
}